import {
    RaikoCustomSelect,
    RaikoGridOneColumn,
    RaikoImageCropper,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSimpleInputOutlined,
    raikoCustomSelectItemGenerator,
    RaikoGridThreeColumn,
    showErrorMessage,
    showWarningMessage,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    convertPersianDateToUniversalDate,
    showSuccessMessage,
    RaikoDatePicker
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import React from "react";
import {GenderDeterminationSelection} from "../userInfromation/UserInformation";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthState} from "../../context/AuthContext";
import {UserService} from "../../serverService/userService/UserService";

export default function AddNewUser(
    {
        handleAddNewItemToTable
    }) {
    const groupService = new GroupsService()
    const service = new UserService()
    const loading = new LoadingHelper(useLoadingDispatcher());
    const {fundID} = useAuthState()
    //
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [gender, setGender] = useState("MALE");
    const [nationalCode, setNationalCode] = useState("");
    const [personalCode, setPersonalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [telephone, setTelephone] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [education, setEducation] = useState("");
    const [job, setJob] = useState("");
    const [groupSelectedID, setGroupSelectedID] = useState(1);
    const [groupList, setGroupList] = useState([]);
    const [address, setAddress] = useState("");
    //
    const [isLoading, setIsLoading] = useState(false)
    const [avatarFile, setAvatarFile] = useState()
    const [avatarImage, setAvatarImage] = useState("");

    useEffect(() => {
        getGroupListFromServer()
    }, [])

    function getGroupListFromServer() {
        loading.show()
        groupService.getGroups(fundID, 0, 1000000).then(
            response => {
                setGroupList([])
                response.data.map((item) => {
                    setGroupList(prevState => [...prevState,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])

                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function checkFields() {
        let message = ""
        let state = false

        if (firstName.length === 0)
            message = "لطفا نام کاربر را به درستی وارد نمایید."
        else if (lastName.length === 0)
            message = "لطفا نام خانوادگی کاربر را به درستی وارد نمایید."
        else if (nationalCode.length < 8)
            message = "لطفا کد ملی کاربر را به درستی وارد نمایید."
        else if (userName.length < 8)
            message = "نام کاربری می بایست حداقل ۸ کاراکتر باشد."
        else if (password.length < 8)
            message = "رمز عبور می بایست بیش از ۸ کاراکتر باشد"
        else if (typeof phoneNumber === 'undefined' || (phoneNumber.length > 0 && phoneNumber.length !== 11))
            message = "لطفا شماره همراه کاربر را به درستی وارد نمایید."
        else if (birthDate && birthDate.length > 0 && birthDate.length !== 10)
            message = "لطفا تاریخ تولد کاربر را به درستی وارد نمایید."
        else if (groupSelectedID === -1)
            message = "لطفا گروه کاربر را مشخص نمایید."
        else
            state = true

        if (message && message.length > 0)
            showWarningMessage(message)

        return state
    }

    function handleAddNewUser() {
        if (checkFields()) {
            loading.show()
            service.addNewUser(
                fundID,
                avatarFile,
                firstName,
                lastName,
                userName,
                password,
                gender,
                nationalCode,
                personalCode,
                phoneNumber,
                telephone,
                convertPersianDateToUniversalDate(birthDate),
                education,
                job,
                groupSelectedID,
                address,
                true
            ).then(response => {
                showSuccessMessage("عضو جدید با موفقیت افزوده شد.")
                handleAddNewItemToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    const updateAvatar = (file, image) => {
        setAvatarFile(file)
        setAvatarImage(image)
    }


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoImageCropper
                avatarFile={avatarImage}
                updateAvatar={updateAvatar}
            />
            <RaikoGridThreeColumn>
                <RaikoSimpleInputOutlined
                    labelText={"نام *"}
                    setValue={setFirstName}
                    value={firstName}/>
                <RaikoSimpleInputOutlined
                    labelText={"نام خانوادگی *"}
                    setValue={setLastName}
                    value={lastName}/>
                <RaikoCustomSelect
                    labelText={"گروه *"}
                    setValue={setGroupSelectedID}
                    items={groupList}
                    value={groupSelectedID}/>
                <RaikoSimpleInputOutlined
                    labelText={"نام کاربری *"}
                    setValue={setUserName}
                    value={userName}/>
                <RaikoSimpleInputOutlined
                    labelText={"رمز عبور *"}
                    setValue={setPassword}
                    value={password}/>
                <RaikoCustomSelect
                    labelText={"جنسیت *"}
                    setValue={setGender}
                    items={[
                        raikoCustomSelectItemGenerator(GenderDeterminationSelection.MALE.key, GenderDeterminationSelection.MALE.name),
                        raikoCustomSelectItemGenerator(GenderDeterminationSelection.FEMALE.key, GenderDeterminationSelection.FEMALE.name),
                    ]}
                    value={gender}
                />
                <RaikoNumberInputOutlined
                    maxLength={"10"}
                    value={nationalCode}
                    setValue={setNationalCode}
                    labelText={"* کدملی"}
                />
                <RaikoNumberInputOutlined
                    maxLength={"10"}
                    value={personalCode}
                    setValue={setPersonalCode}
                    labelText={"شماره شناسنامه"}
                />
                <RaikoMobileInputOutlined
                    labelText={"* شماره همراه"}
                    setValue={setPhoneNumber}
                    value={phoneNumber}/>
                <RaikoMobileInputOutlined
                    labelText={"شماره تلفن ثابت"}
                    setValue={setTelephone}
                    value={telephone}/>
                <RaikoDatePicker
                    label={"تاریخ تولد *"}
                    date={birthDate}
                    setDate={setBirthDate}
                />
                {/*<RaikoSimpleInputOutlined
                    labelText={"تحصیلات"}
                    setValue={setEducation}
                    value={education}/>
                <RaikoSimpleInputOutlined
                    labelText={"شغل"}
                    setValue={setJob}
                    value={job}/>*/}

            </RaikoGridThreeColumn>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    onClick={handleAddNewUser}
                    loading={isLoading}
                />
            </RaikoFlexAlignEnd>

        </RaikoGridOneColumn>
    )
}